import React from 'react';
import { IComponentProps } from '@interfaces/i-common';
import style from './index.module.less';

const AppSideBar: React.FC<IComponentProps> = (props) => {
  return <div className={style.appSideBar}>{props.children}</div>;
};

export default AppSideBar;
